import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ReportBookmarkVm} from '../rtkquery/paylogikApi';

type ReportingState = {
    reportBookmarks: ReportBookmarkVm[];
    bookmarks: ReportBookmarkVm[];
    selectedBookmark: ReportBookmarkVm;
};

const baseSessionState = {
    reportBookmarks: [] as ReportBookmarkVm[],
    bookmarks: [] as ReportBookmarkVm[],
} as ReportingState;

const slice = createSlice({
    name: 'reporting',
    initialState: baseSessionState,
    reducers: {
        setReportBookmarks: (
            state,
            action: PayloadAction<ReportBookmarkVm[]>
        ) => {
            state.reportBookmarks = action.payload.map((value, index) => {
                {
                    value.id = index * -1;
                    return value;
                }
            });
        },
        setUserBookmarks: (
            state,
            action: PayloadAction<ReportBookmarkVm[]>
        ) => {
            //Need to pull thes from the database / api with an async thunk.
            state.bookmarks = action.payload;
        },
    },
    extraReducers: (builder) => {},
});

export const {setReportBookmarks, setUserBookmarks} = slice.actions;

export default slice.reducer;

//export const selectCurrentUser = (state: RootState) => state.auth.user;
